module.exports = __webpack_public_path__ + "img/contact_email_icon.8adb2b38.svg";